import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import MovieCard from "@/components/base/MovieCard";
import NewsListItem from "@/components/base/NewsListItem";
import { heroSlides, categoryEntries } from "@/mocks/home";
import { movies } from "@/mocks/movies";
import { news } from "@/mocks/news";

export default function Home() {
  const hotMovies = movies.filter((m) => m.hot).slice(0, 10);
  const latestNews = news.slice(0, 4);
  const sidebarNews = news.slice(4, 9);
  const ranking = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <div className="w-full">
      <HeroCarousel slides={heroSlides} />

      {/* 分类快捷入口 */}
      <section className="w-full px-4 md:px-8 mt-6 md:mt-8 relative z-20">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {categoryEntries.map((c) => (
            <Link
              key={c.key}
              to={c.key === "news" ? "/news" : `/category/${c.key}`}
              className="flex items-center gap-3 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-400 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <p className="text-sm font-heading font-semibold text-foreground-950 whitespace-nowrap">
                  {c.label}
                </p>
                <p className="text-[11px] text-foreground-500 truncate hidden sm:block">{c.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 热门影视推荐 */}
      <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
        <div className="flex items-end justify-between mb-5">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
              热门影视推荐
            </h2>
            <p className="mt-1 text-xs md:text-sm text-foreground-600">
              正在热播与高人气作品，帮你告别选择困难
            </p>
          </div>
          <Link
            to="/category/recommend"
            className="hidden sm:flex items-center gap-1 text-sm font-label text-accent-600 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {hotMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </section>

      {/* 最新影视资讯 + 热播榜 */}
      <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between mb-5">
              <div>
                <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
                  最新影视资讯
                </h2>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">
                  电影与电视剧的最新动态，一网打尽
                </p>
              </div>
              <Link
                to="/news"
                className="flex items-center gap-1 text-sm font-label text-accent-600 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                更多资讯
                <i className="ri-arrow-right-s-line text-lg"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              {latestNews.map((item) => (
                <NewsListItem key={item.id} item={item} />
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-6">
            <div className="rounded-lg bg-background-50 border border-background-200 p-5">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className="ri-bar-chart-fill text-lg"></i>
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-950">热播榜</h3>
              </div>
              <ol className="flex flex-col gap-3">
                {ranking.map((m, i) => (
                  <li key={m.id}>
                    <Link
                      to={`/detail/${m.id}`}
                      className="flex items-center gap-3 cursor-pointer group"
                    >
                      <span
                        className={`w-6 h-6 rounded text-xs font-label font-bold flex items-center justify-center shrink-0 ${
                          i < 3
                            ? "bg-accent-500 text-primary-950"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="flex-1 text-sm text-foreground-900 truncate group-hover:text-accent-600 transition-colors">
                        {m.title}
                      </span>
                      <span className="text-xs font-label text-accent-600">{m.rating.toFixed(1)}</span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg bg-background-50 border border-background-200 p-5">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center">
                  <i className="ri-bookmark-line text-lg"></i>
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-950">更多资讯</h3>
              </div>
              <ul className="flex flex-col gap-3 max-h-64 overflow-y-auto no-scrollbar pr-1">
                {sidebarNews.map((n) => (
                  <li key={n.id}>
                    <Link
                      to={`/news/${n.id}`}
                      className="block text-sm text-foreground-700 hover:text-accent-600 transition-colors line-clamp-2 cursor-pointer"
                    >
                      <i className="ri-article-line mr-1.5 text-foreground-400"></i>
                      {n.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      {/* 编辑精选 CTA */}
      <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
        <div className="relative rounded-lg overflow-hidden bg-primary-950">
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20dark%20theater%20hall%20with%20rows%20of%20glowing%20red%20seats%20and%20a%20bright%20screen%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20atmospheric%20mood%2C%20minimalist%20composition%2C%20no%20text&width=1600&height=400&seq=hp-cta-01&orientation=landscape"
            alt="编辑精选片单"
            title="欲望之岛 编辑精选片单"
            className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
          />
          <div className="relative z-10 px-6 md:px-12 py-10 md:py-14">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50">
              编辑精选片单
            </h2>
            <p className="mt-2 text-sm md:text-base text-background-200 max-w-xl">
              由编辑团队精心挑选的必看影视合集，从悬疑烧脑到治愈温情，总有一部适合今晚的你。
            </p>
            <Link
              to="/category/recommend"
              className="inline-flex items-center gap-1 mt-6 px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-label font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              去看看
              <i className="ri-arrow-right-s-line text-lg"></i>
            </Link>
          </div>
        </div>
      </section>

      <div className="h-10 md:h-16"></div>
    </div>
  );
}